import { useReveal } from "@/hooks/useReveal";
import { Check } from "lucide-react";

const ITEMS = ["Кашемировые пальто", "Шубы", "Пуховики", "Новые бренды", "Размеры", "Цены"];

export const Catalog = () => {
  const ref = useReveal();
  return (
    <section id="catalog" ref={ref} data-testid="catalog-section" className="py-28 md:py-36" style={{ background: "var(--paper-2)" }}>
      <div className="pw-container">
        <div className="grid lg:grid-cols-2 gap-14 lg:gap-20 items-center">
          <div className="reveal order-2 lg:order-1">
            <div className="rounded-2xl overflow-hidden aspect-[4/5]">
              <img
                src="/media/catalog-main.jpg"
                alt="Каталог Angiolini — пальто с отделкой из соболя"
                loading="lazy"
                className="w-full h-full object-cover"
                style={{ objectPosition: "center 22%" }}
              />
            </div>
          </div>

          <div className="order-1 lg:order-2">
            <span className="pw-eyebrow reveal">Каталог</span>
            <h2 className="pw-h2 reveal mt-6">
              Все новые коллекции Италии появляются здесь.
            </h2>
            <p className="reveal mt-6 text-base leading-relaxed max-w-md" style={{ color: "var(--grey-1)" }}>
              Следите за поступлениями, сравнивайте модели, сохраняйте
              понравившиеся образы и узнавайте актуальные цены в любое время.
            </p>
            <div className="grid grid-cols-2 gap-x-8 gap-y-4 mt-10 max-w-md">
              {ITEMS.map((item, i) => (
                <div key={i} data-testid={`catalog-item-${i}`} className="reveal flex items-center gap-3" style={{ transitionDelay: `${i * 60}ms` }}>
                  <Check size={16} strokeWidth={2.5} style={{ color: "var(--accent)" }} className="shrink-0" />
                  <span className="text-[15px] font-medium">{item}</span>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
